import HttpService from "./HttpService";

const DetalleService = {
    async obtenerData(id){
        return await HttpService.post('/operadora/getDetails', {
            id: id
        })
    }
}

export default DetalleService